// extracted by mini-css-extract-plugin
module.exports = {"containerDiv":"VideoPlayerPaged__containerDiv__3reoJ","thumbanil":"VideoPlayerPaged__thumbanil__y3s1_","titulo_video":"VideoPlayerPaged__titulo_video__1OKeV"};